import React from 'react';
import { X, BookOpen, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
interface PracticeHeaderMinimalProps {
  currentQuestion: number;
  totalQuestions: number;
  streak?: number; // Optional - only shown in practice mode
  onExit: () => void;
  onToggleCheatSheet?: () => void; // Optional - only available in practice mode
  isCheatSheetOpen?: boolean;
}
export function PracticeHeaderMinimal({
  currentQuestion,
  totalQuestions,
  streak,
  onExit,
  onToggleCheatSheet,
  isCheatSheetOpen = false
}: PracticeHeaderMinimalProps) {
  const progress = currentQuestion / totalQuestions * 100;
  return <header className="bg-white border-b border-slate-200 sticky top-0 z-40 shadow-sm" data-id="element-4581">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2.5 sm:py-3" data-id="element-4582">
        <div className="flex items-center justify-between gap-2 sm:gap-4" data-id="element-4583">
          {/* Left: Progress - MOBILE OPTIMIZED */}
          <div className="flex-1 max-w-xs sm:max-w-md" data-id="element-4584">
            <div className="flex items-center justify-between mb-1.5 sm:mb-2" data-id="element-4585">
              <span className="text-xs sm:text-sm font-bold text-slate-700" data-id="element-4586">
                Vraag {currentQuestion}/{totalQuestions}
              </span>
              <span className="text-xs font-semibold text-slate-500" data-id="element-4587">
                {Math.round(progress)}%
              </span>
            </div>
            <div className="h-1.5 sm:h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-4588">
              <div className="h-full bg-gradient-to-r from-indigo-500 to-violet-500 rounded-full transition-all duration-300" style={{
              width: `${progress}%`
            }} data-id="element-4589" />

            </div>
          </div>

          {/* Center: Streak (only in practice mode) - HIDE ON SMALL MOBILE */}
          {streak !== undefined && streak > 0 && <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-amber-50 rounded-xl border border-amber-200" data-id="element-4590">
              <Zap className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-4591" />
              <span className="text-sm font-bold text-amber-700" data-id="element-4592">
                {streak} op rij!
              </span>
            </div>}

          {/* Right: Actions - MOBILE OPTIMIZED */}
          <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-4593">
            {/* FIXED: Show hint button on all screen sizes when available */}
            {onToggleCheatSheet && <Button onClick={onToggleCheatSheet} variant="secondary" size="sm" className={`${isCheatSheetOpen ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : ''}`} data-id="element-4594">

                <BookOpen className="w-4 h-4 sm:mr-2" data-id="element-4595" />
                <span className="hidden sm:inline" data-id="element-4596">Uitleg</span>
              </Button>}

            <Button onClick={onExit} variant="secondary" size="sm" className="text-slate-600 hover:text-slate-900 px-2 sm:px-4" data-id="element-4597">

              <X className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-4598" />
              <span className="hidden sm:inline ml-2" data-id="element-4599">Stoppen</span>
            </Button>
          </div>
        </div>
      </div>
    </header>;
}